/**
 * Who a Secure Drop message went to: the address its link was emailed to, or
 * "Link only" when the sender copied the link. Messages sent before this was
 * recorded (3 Nov 2026) show "Not recorded".
 */
export function sentTo(message) {
  if (message?.recipientEmail) return message.recipientEmail;
  if (message?.deliveredBy === 'link') return 'Link only';
  return 'Not recorded';
}
